var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_403",
    "data-name": "Rectangle 403",
    width: 40,
    height: 40,
    transform: "translate(0.5 0.5)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_1_1",
    "data-name": "calendar(1) 1",
    transform: "translate(-0.5 -0.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M0,10.969V36.914a3.168,3.168,0,0,0,3.164,3.164H37.336A3.168,3.168,0,0,0,40.5,36.914V10.969Z",
    transform: "translate(0 -0.369)",
    fill: "#d8dce1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M37.336,1.8H3.164A3.168,3.168,0,0,0,0,4.965v5.7H40.5v-5.7A3.168,3.168,0,0,0,37.336,1.8ZM5.062,8.129a1.9,1.9,0,1,1,1.9-1.9A1.9,1.9,0,0,1,5.062,8.129Zm30.375,0a1.9,1.9,0,1,1,1.9-1.9A1.9,1.9,0,0,1,35.437,8.129Z",
    transform: "translate(0 -0.061)",
    fill: "#ff4f19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M5.206,7.148A.949.949,0,0,1,4.257,6.2V1.77a.949.949,0,1,1,1.9,0V6.2A.949.949,0,0,1,5.206,7.148Z",
    transform: "translate(-0.143 -0.028)",
    fill: "#5c546a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M36.64,7.148A.949.949,0,0,1,35.69,6.2V1.77a.949.949,0,1,1,1.9,0V6.2A.949.949,0,0,1,36.64,7.148Z",
    transform: "translate(-1.202 -0.028)",
    fill: "#5c546a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e5b3ebf50fb50df6f51fd9d903348e7f.svg";
export { ForwardRef as ReactComponent };